import React, { useEffect } from 'react';
import Page from '@Containers/Page';
import { Switch, withRouter, useLocation } from 'react-router-dom';
import ConnectedRoute from '@AppRoutes/ConnectedRoute';

import NewRelicService from '@Services/NewRelicService';
import RouteChangeTracking from '@Services/RouteChangeTracking';

import RetroSynthesisProjectsContainer from '@Pages/RetroSynthesis/RetroSynthesisProjects/RetroSynthesisProjectsContainer';
import DrawStructureContainer from '@Pages/RetroSynthesis/DrawStructure/DrawStructureContainer';
import RsRootInitializerContainer from '@Pages/RetroSynthesis/RetroSynthesisRoot/RsRootInitializerContainer';
import Tooltip, { overridePositionTopLeft, TooltipConstants } from '@Components/Tooltip';
import RsBreadcrumbsContainer from '@Pages/RetroSynthesis/RsBreadcrumbs/RsBreadcrumbsContainer';
import ProjectRoutesContainer from '@Pages/RetroSynthesis/ProjectRoutes/ProjectRoutesContainer';
import ProjectRouteContainer from '@Pages/RetroSynthesis/ProjectRoute';
import StructureOptionContainer from '@Pages/RetroSynthesis/StructureOption/StructureOptionContainer';
import { saveRsLocation } from '@Pages/RetroSynthesis/RetroSynthesisRoot/utils/rsSavedLocation';
import LinkOptionContainer from '@Pages/RetroSynthesis/LinkOption/LinkOptionContainer';
import { RsRoute } from '../routes';

import './RetroSynthesisRoot.theme.scss';

export function RetroSynthesisRoot() {
  const location = useLocation();

  // Save RS last visited location
  useEffect(() => {
    // Don't save location if it is root '/retrosynthesis'
    if (location && RsRoute.isRsLocation(location) && location.pathname !== RsRoute.ROOT) {
      NewRelicService.trackRouteChanges(location.pathname);
      saveRsLocation(location);
    }
  }, [location]);

  useEffect(() => {
    RouteChangeTracking.handleSkipLinkFocus();
  }, [location]);

  return (
    <Page withFooter={false} className="retro-synthesis-root" pageClassName="hidden-overflow">
      <StructureOptionContainer />
      <LinkOptionContainer />
      <RsBreadcrumbsContainer />
      <div className="retro-synthesis-root__content">
        <Switch>
          <ConnectedRoute path={RsRoute.DRAW_STRUCTURE} render={() => <DrawStructureContainer />} />
          <ConnectedRoute path={RsRoute.PROJECT_ROUTE} render={() => <ProjectRouteContainer />} />
          <ConnectedRoute path={RsRoute.PROJECT} render={() => <ProjectRoutesContainer />} />
          <ConnectedRoute path={RsRoute.PROJECTS_LIST} render={() => <RetroSynthesisProjectsContainer />} />
          <ConnectedRoute exact path={RsRoute.ROOT} render={() => <RsRootInitializerContainer />} />
        </Switch>
      </div>
      <Tooltip id={TooltipConstants.ids.Retrosynthesis} />
      <Tooltip id={TooltipConstants.ids.RetrosynthesisParams} offset={{ top: 100 }} place="left" />
      <Tooltip id={TooltipConstants.ids.RetrosynthesisStructureIcon} />
      <Tooltip id={TooltipConstants.ids.ResultStructureComponent} />
      <Tooltip id={TooltipConstants.ids.TreeViewToolbar} html overridePosition={overridePositionTopLeft} multiline />
    </Page>
  );
}

export default withRouter(RetroSynthesisRoot);
